import { FC } from 'react';
import { GridItem, GridItemProps, useToken } from '@chakra-ui/react';

import webView from 'common/webView';

import { BODY_GRID_AREA } from '../../constants';

const Body: FC<GridItemProps> = ({ children, ...gridItemProps }) => {
  const [space32] = useToken('space', ['space-32']);

  const { isInWebView } = webView;

  if (isInWebView) {
    return (
      <GridItem
        paddingX="space-16"
        {...gridItemProps}
        gridArea={BODY_GRID_AREA}
      >
        {children}
      </GridItem>
    );
  }

  /// Some CSS hacks with margins and paddings to prevent box shadows from being cutoff horizontally
  return (
    <GridItem
      marginLeft="-space-16"
      overflowY="auto"
      padding="space-16"
      width={`calc(100% + ${space32})`}
      {...gridItemProps}
      gridArea={BODY_GRID_AREA}
    >
      {children}
    </GridItem>
  );
};

export default Body;
